import countriesJSON from "@/assets/json/countries.json"

var mixin = {
  methods: {
    getCountry: code => {
      return countriesJSON.find(item => {
        return item.alpha2Code == code
      })
    },
    getCountryName: code => {
      var country = countriesJSON.find(item => {
        return item.alpha2Code == code
      })
      if (country != null) {
        return country.name
      } else {
        return ""
      }
    }
  }
}

export { mixin }
